import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { AlertTriangleIcon, DollarSignIcon } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-white py-16 md:py-24" ref={ref} data-id="element-223">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-225">
          <div className="flex items-center gap-3 mb-6" data-id="element-226">
            <AlertTriangleIcon className="w-6 h-6 text-gold-600" aria-hidden="true" data-id="element-227" />
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-navy-900" data-id="element-228">
              El error que cometen todas las familias
            </h2>
          </div>

          <p className="font-body text-lg text-gray-700 leading-relaxed mb-6" data-id="element-229">
            La mayoría de las familias que se mudan a EE.UU. cometen el mismo
            error:{' '}
            <strong className="text-navy-900" data-id="element-230">
              intentan resolver todo al mismo tiempo.
            </strong>{' '}
            Alquilan un auto carísimo en el aeropuerto, buscan casa en zonas que
            no conocen y se frustran cuando el banco les cierra la puerta por no
            tener una "prueba de residencia".
          </p>

          {/* Cost callout */}
          <div className="bg-navy-900 rounded-xl p-6 sm:p-8 mb-8" data-id="element-231">
            <div className="flex items-start gap-4" data-id="element-232">
              <div className="flex-shrink-0 w-12 h-12 bg-gold-500/20 rounded-full flex items-center justify-center" data-id="element-233">
                <DollarSignIcon className="w-6 h-6 text-gold-500" aria-hidden="true" data-id="element-234" />
              </div>
              <div data-id="element-235">
                <p className="font-heading text-2xl sm:text-3xl font-bold text-gold-500 mb-2" data-id="element-236">
                  $5,000 – $12,000 USD
                </p>
                <p className="font-body text-navy-100 leading-relaxed" data-id="element-237">
                  Es lo que hemos visto perder a familias en su primer mes
                  simplemente por no entender la{' '}
                  <strong className="text-white" data-id="element-238">
                    "dependencia de trámites"
                  </strong>
                  . Si haces el paso B antes que el paso A, el sistema te
                  bloquea y terminas pagando el{' '}
                  <em className="text-gold-400" data-id="element-239">"Impuesto al Inmigrante"</em>:
                  precios más altos, depósitos dobles y semanas perdidas en
                  hoteles o Airbnbs costosos.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}